import React from "react";

import { buttonVariants } from "@client/shadcn/ui/button";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList, navigationMenuTriggerStyle } from "@client/shadcn/ui/navigation-menu";
import { CSRFToken, Context } from "@reactivated";

interface Props {
    className?: string;
}

export const NavBar = (props: Props) => {
    const user = React.useContext(Context).user;
    return (
        <NavigationMenu className="justify-between max-w-full m-4">
            <NavigationMenuList className="gap-4">
                <NavigationMenuItem>
                    <a href="/">
                        <NavigationMenuLink className={[
                            navigationMenuTriggerStyle(),
                            buttonVariants({
                                variant: "ghost",
                                size: "lg",
                            }),
                        ].join(" ")}>Home</NavigationMenuLink>
                    </a>
                </NavigationMenuItem>
                {user.id ? (
                    <NavigationMenuItem>
                        <a href="/projects/">
                            <NavigationMenuLink className={[
                                navigationMenuTriggerStyle(),
                                buttonVariants({
                                    variant: "ghost",
                                    size: "lg",
                                }),
                            ].join(" ")}>Projects</NavigationMenuLink>
                        </a>
                    </NavigationMenuItem>
                ) : null}
            </NavigationMenuList>
            <NavigationMenuList className="gap-4">
                {user.is_staff ? (
                    <NavigationMenuItem>
                        <a href="/admin/">
                            <NavigationMenuLink className={[
                                navigationMenuTriggerStyle(),
                                buttonVariants({
                                    variant: "secondary",
                                    size: "lg",
                                }),
                            ].join(" ")}>Admin Panel</NavigationMenuLink>
                        </a>
                    </NavigationMenuItem>
                ) : null}
                <NavigationMenuItem>
                    <form
                        method="POST"
                        action={user.id ? "/accounts/logout/" : "/accounts/auth0rbac/login/"}
                    >
                        <CSRFToken />
                        <button className="cursor-pointer" type="submit">
                            <NavigationMenuLink
                                className={[
                                    navigationMenuTriggerStyle(),
                                    buttonVariants({
                                        variant: user.id ? "destructive" : "secondary",
                                        size: "lg",
                                    }),
                                ].join(" ")}
                            >
                                {user.id ? "Logout" : "Login"}
                            </NavigationMenuLink>
                        </button>
                    </form>
                </NavigationMenuItem>
            </NavigationMenuList>
        </NavigationMenu>
    );
};
